import {IStore} from "modules/types/store";
import {createSelector} from "reselect";
import {RequestState} from "modules/enums";

export const getJsonState = (state: IStore) => {
	return state.jsons;
};
export const isHelpLoading = createSelector(
	getJsonState,
	({requestState, faqRequestState}) =>
		requestState === RequestState.Requested || faqRequestState === RequestState.Requested
);
